import { Component, computed, input } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {ComponentEntity} from "../../../entities/component-entity";
import { getAlignmentText} from "../../../commons/compontents-utils";
import {CommonsUI, CONSTANTS} from '../../../commons/constans';
import {PositionDirective} from "../../../directives/position.directive";
import {ClickComponentDirective} from "../../../directives/click-component.directive";
import {PositionAlignment} from "../../../entities/properties";
import {defaultComponentEntity} from "../../../commons/defaults-components";
import {AmadWebNetworkService} from "../../../network/amad-web-network.service";

@Component({
  selector: 'lib-button-image',
  standalone: true,
  imports: [CommonModule, PositionDirective, ClickComponentDirective, NgOptimizedImage],
  templateUrl: './button-image.component.html',
  styleUrl: './button-image.component.css'
})
export class ButtonImageComponent {
  component = input<ComponentEntity>(defaultComponentEntity());
  protected readonly CommonsUI = CommonsUI;
  protected readonly getAlignmentText = getAlignmentText;
  getAlignmentImage(positionAlignment: PositionAlignment): string {
    switch (positionAlignment) {
      case PositionAlignment.LEFT:
        return 'flex-row-reverse';
      case PositionAlignment.BOTTOM:
        return 'flex-col';
      case PositionAlignment.RIGHT:
        return 'flex-row';
      case PositionAlignment.TOP:
        return 'flex-col-reverse';
    }
  }

  constructor( private amadWebNetwork:AmadWebNetworkService ) {
  }
  protected readonly onclick = onclick;
}
